module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAMAAACKYC6uAAAAVFBMVEUAAACoqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKjG0dzsAAAAHHRSTlMA+WHDWEo57H/+5pmTa3svLNzZzsu3paOMQx0JGQ0OhgAAAHBJREFUCNdNjkkShSAMRDshEAZBnP53uP89Fdn4NqlOVQ9ouDQRTcmhM5pgikh5ztg001bBy8KoGzEgIQOWiicL5CCIj8ZvAIY/gBwR7fdhI0Rds/jX4lRaqL/A68q4vHKv1f04z2NXU9FxaSaa+7AbRh8EGgvoBl8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/wnds_eyeicon.png
// module id = gmSz
// module chunks = 1